import parse from "html-react-parser";
import { getBlockId } from "../../../../utils/forms/form.fields.utils";

const IFrame = props => {
	const {block} = props;
	return (
		<div className="customContainer" id={getBlockId(block)}>
			<div className="row mxc-auto">
				<div className="col s12 m10 l10 offset-m1 offset-l1">
					<div className="iframe-player">
						{parse(block.data.embedCode)}
					</div>
				</div>
			</div>
		</div>
	)
};

export default IFrame;